import { render, staticRenderFns } from "./ChatDemoV2.vue?vue&type=template&id=2e6b695e&scoped=true"
import script from "./ChatDemoV2.vue?vue&type=script&lang=js"
export * from "./ChatDemoV2.vue?vue&type=script&lang=js"
import style0 from "./ChatDemoV2.vue?vue&type=style&index=0&id=2e6b695e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b695e",
  null
  
)

export default component.exports